import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getAreaOfInterest} from '../../services/projectService';
import Plot from 'react-plotly.js';

const ProfileChart = ({data:{data, feature}}) =>{
    //const [loading, setLoading] = useState(true);
    const [error, setError] = useState(true);
    const [chart, setChart] = useState(null);

  useEffect(() => {
    console.log(data, feature);
      updateChart();
  }, [])

  const updateChart = ()=> {
    console.log(feature)
    const labels = [];
    const ground = [];
    const profile = [];
    const step = data.x_max / data.values.length;
    for (let i = 0; i < data.values.length; i+=5) {
        labels.push((step*i).toFixed(1));
        profile.push(data.values[i]);
        if (data.values[i]>feature.properties.height_ground) {
            ground.push(feature.properties.height_ground);
        }
        else {
            ground.push(data.values[i])
        }
    }
    setChart([{
      x: labels,
      y: ground,
      fill: 'tonexty',
      type: 'scatter',
      fillcolor: '#9a9aa4',
      line: {
        color: '#9a9aa4'
      },
      name: "Ground",
    },{
      x: labels,
      y: profile,
      fill: 'tonexty',
      type: 'scatter',
      fillcolor: '#89CFF0',
      line: {
        color: '#89CFF0'
      },
      name: "Profile",
    }]
    )

  }


  return (
      <Plot
        data={chart}
        layout={{
          xaxis: {
            autotick: false,
            ticks: 'outside'},
          autosize:true,
          title: {
            text:`ID: ${feature.properties.id} / NAME: ${feature.properties.name}`,
            font: {
              family: 'HelveticaNeue, monospace',
              size: 24
            },
            xref: 'paper',
            x: 0.05
          }}}
          useResizeHandler={true}
          style={{width: "100%", height: "100%"}}

      />
  );



}

export default ProfileChart;